import React from 'react';
import { countries } from './countries';
import Select from 'rc-select';

import './rc-select.css';

const PhoneCodeSelect = ( {onChange, setDirty} ) => {
  return (
    <Select
      showArrow={false}
      showSearch={true}
      optionLabelProp='label'
      dropdownMatchSelectWidth={288}
      filterOption={(input, option) => {
        return ((input, country, phoneCode) => country.indexOf(input) >= 0 || phoneCode.startsWith(input) || phoneCode.startsWith('+' + input))(
          input.toLowerCase(),
          option.children.props.children.props.children[0].toLowerCase(),
          option.children.props.children.props.children[2].toLowerCase()
        );
      }}
      optionFilterProp='children'
      placeholder={<span>-- Code --</span>}
      onChange={onChange}
      onBlur={setDirty}
    >
      {countries.map((v, i) => (
        <Select.Option
          key={i}
          value={v.alpha2code + v.phoneCode}
          label={
            <div>
              <span>{v.phoneCode}</span>
            </div>
          }
        >
          <div>
            <span>
              {v.name} ({v.phoneCode})
            </span>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default PhoneCodeSelect;



// WEBPACK FOOTER //
// ./src/ndc/request/phoneCodeSelect.js